import { render } from "./LearnButton.vue?vue&type=template&id=3e4e0c35&scoped=true"
import script from "./LearnButton.vue?vue&type=script&lang=js"
export * from "./LearnButton.vue?vue&type=script&lang=js"

import "./LearnButton.vue?vue&type=style&index=0&id=3e4e0c35&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-3e4e0c35"

export default script